// extracted by mini-css-extract-plugin
export default {"materialsList":"collapse-item_materialsList__Gq4KL"};